<template>

</template>
<script>
    export default {
        mounted() {
            window.location = '/docs/master/overview';
        }
    }
</script>